"use strict";

import { http } from '../../core';
import config from '../../app.config'
const RequestbaseURL = http.create({baseURL:config.BASEURL});
const RequestMockURL = http.create({ baseURL: config.mockUrl });
// const RequestITSMURL = http.create({ baseURL: config.BASEURL });

export default {
    getdictionary(){
        return RequestbaseURL.get("appcenter/apptree/v1/data/dictionary")
    },
    // 全部应用列表
    appList(params) {
        return RequestbaseURL.get('appcenter/apptree/v1/app/list', params);
    },
    //全部应用列表（有关键字搜索功能）
    getAppList(params){
        return RequestbaseURL.get('appcenter/apptree/v1/app/search/list',params)
    },
    // 搜索应用
    appSearch(params) {
        return RequestbaseURL.get('appcenter/apptree/v1/app/search', { name: params });
    },
    //操作切换事件
    operateEvent(params){
        return RequestbaseURL.post('appcenter/apptree/v1/app/operate',params)
    },

    // 审批
    v1Approval(params) {
        return RequestbaseURL.post('approval/v1/approval', params);
    },

    // 获取要审批的数据
    getApproval(params) {
        return RequestbaseURL.get('approval/v1/approval', params);
    },

    // 测试接口
    testPort(params) {
        return RequestMockURL.get('cicd/test/port', params);
    },

}
